<script setup>
  import { ref, computed, watch } from 'vue';
  import ModalTextInput from '@/components/controls/ModalTextInput.vue';

  const props = defineProps({
    device: {
      type: Object,
      default: null,
    },
  });

  const name = ref('');

  const errorCount = computed(() => 0);

  function validate() {
    return true;
  }

  function buildPayload() {
    return {
      name: name.value,
      address: props.device?.address || '',
    };
  }

  watch(() => props.device, (device) => {
    name.value = device?.name || '';
  }, { immediate: true });

  defineExpose({ validate, buildPayload, errorCount });
</script>

<template>
  <div class="jwx-modal__section">
    <div class="jwx-modal__section-body">
      <ModalTextInput
        v-model="name"
        id="device-iphone-name"
        name="device-iphone-name"
        labelText="Name"
        subText="Max 64 characters"
      />
    </div>
  </div>
</template>
